import { render, staticRenderFns } from "./third_step.vue?vue&type=template&id=48b773b8&scoped=true&"
import script from "./third_step.vue?vue&type=script&lang=js&"
export * from "./third_step.vue?vue&type=script&lang=js&"
import style0 from "./third_step.vue?vue&type=style&index=0&id=48b773b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b773b8",
  null
  
)

export default component.exports